/**
 * @fileOverview Utilities for FPTI tracking.
 * @author jzetlen
 */
// Backbone serves as the global event bus for FPTI events.
import Backbone from 'backbone';

/**
 * Create a `trackLink` function that will log FPTI events to the global event
 * bus under the name 'trackLink'.
 * @param {string} prefix A common prefix, such as 'main:walletweb:activity',
 *			for all events logged by this function.
 * @return {function} A function that takes a "name" parameter for the eventy
 *       to track, and an optional "shortName" parameter for the 'short name',
 *       which if omitted will be the part of "name" after the last colon
 *       present.
 *
 *       See public/js/widgets/analytics.js for the meaning of the below vars.
 */
export function createLinkTracker (prefix) {
	return function trackLink(name, shortName) {
		Backbone.trigger(
			'trackLink',
			null,                               // linkName
			shortName || name.split(':').pop(), // pageName
			[prefix, name].join(':') + ':',     // pageName2
			null,                               // trackType
			'link'                              // transactionDetailsLinks
		);
	};
}



// WEBPACK FOOTER //
// ./lib/fpti-utils.es6